import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import { autorun } from 'mobx';
import { inject, observer } from 'mobx-react';
import { HashRouter as Router, Route, NavLink, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { wrapGrid } from 'common/util';
import { regex } from 'common/util';
// import MusicPlayer from 'common/components/music-player/player'; // OLD
// import MusicPlayer from 'client/main-ui/components/music-player'; // NEW - NOT WORKING

import {
	ManageArtists,
	ArtistForm
} from './mng-artists';

import {
	Submissions,
	ViewAudition,
	ArtistInfo
} from './artists';

import {
	ManageFans,
	FanInfo
} from './fans';

import ArtistInfoHeader from './artists/artist-info-header';
import Genres from './genres';
// import HFMPicks from './hfm-picks';
import ManageImages from './manage-images';
import {ManageLists} from './mng-lists';
import { ManageSongs } from './mng-songs';
import { ManageUsers, UserForm } from './mng-users';
import { ManageAlbums } from './mng-albums';
import ManageNewReleases from './manage-new-releases';
import FeaturedArtists from './featured-artists';
import ListEditor from './list-editor';
import ManageDocuments from './manage-documents';

// Coming soon
import Labels from './labels';
import ManageSubscriptions from './manage-subscriptions';
import Dashboard from './dashboard';
import MuzadoRadio from './muzado-radio';

@inject('routingStore', 'artistStore', 'songsStore', 'history', 'userStore')
export class Root extends React.Component {
	constructor (props) {
		super(props);
		autorun(this.onLocationChange);
	}

	render() {
		const muzadoInsiderID = "5fa3eec5f60c6b002a4cf165"; // TODO: Add DB call to pull correct ID. This sample is Bob Marley

		return (
			<Router history={ this.props.history }>
				<div className="admin grid-x">
					{/* <div className="expanded row small-12 grid-x admin-header-holder"> */}
						<div className="grid-x align-middle admin-header">
							<div className="logo-small admin"></div>
							<div className="admin-title">ADMIN PORTAL</div>
						</div>
					{/* </div> */}
					<div className="expanded row small-12 grid-x" >
					<div className="sidebar-container">
						<div className="cell small-2 sidebar-cell">
							<ul className="vertical menu padding-top-3 padding-left-1 padding-right-1">
								<li><NavLink className="primary-link admin" to="/submissions">New Submissions</NavLink></li>
								{/* <li><NavLink className="primary-link admin" to="/labels">Labels</NavLink></li> */}
								<li>
									<NavLink 
										className="primary-link admin" 
										to="/manage-artists"
										isActive={(_, { pathname }) => pathname.match(/^#?\/(manage-artists\/.*)/i) }
									>Artists</NavLink>
								</li>
								<li><NavLink className="primary-link admin" to="/manage-songs">Songs</NavLink></li>
								<li><NavLink className="primary-link admin" to="/manage-albums">Albums</NavLink></li>
								<li><NavLink className="primary-link admin" to="/manage-users">Users</NavLink></li>
								<li>&nbsp;</li>
								<li>
									<NavLink 
										className="primary-link admin" 
										to="/manage-lists"
										isActive={(_, { pathname }) => pathname.match(/^#?\/(manage-lists|list-editor(?!\/NEW_RELEASES))/i) }
									>Lists</NavLink>
								</li>
								<li><NavLink
									className="primary-link admin"
									to={{ 
										pathname: `/list-editor/NEW_RELEASES`,
										data: {
											listType: "NEW_RELEASES",
											returnURL: '/list-editor/NEW_RELEASES'
										}
									}}
								>New Releases</NavLink></li>
								<li>&nbsp;</li>
								<li><NavLink className="primary-link admin" to="/manage-genres">Genres</NavLink></li>
								{/* <li><NavLink className="primary-link admin" to="/manage-images">Images</NavLink></li> */}
								<li>&nbsp;</li>
								<li><NavLink 
									className="primary-link admin" 
									to="/manage-fans/ACTIVE"
									isActive={(_, { pathname }) => pathname.match(/^#?\/(manage-fans\/.*)/i) }
								>Fans</NavLink></li>
								<li><NavLink className="primary-link admin" to="/manage-subscriptions">Subscriptions</NavLink></li>
								<li>&nbsp;</li>
								<li><NavLink className="primary-link admin" to={ "/artist/library/" + muzadoInsiderID }>Muzado Insider</NavLink></li>
								<li><NavLink className="primary-link admin" to="/muzado-radio">Muzado Radio</NavLink></li>
								<li>&nbsp;</li>
								<li><NavLink className="primary-link admin" to="/manage-documents">Content</NavLink></li>
								<li><NavLink className="primary-link admin" to="/dashboard">Dashboard</NavLink></li>
								{/* <li><NavLink to="/manage-hfm-picks">H5picks</NavLink></li> */}
							</ul>
						</div>
					</div>

					<div className="cell auto admin-main-content margin-left-1">
						<Route exact path="/">
							{ <Redirect to="/submissions" /> }
						</Route>

						<Route path="/submissions" exact component={ wrapGrid(Submissions) } />
						<Route path="/submissions/artist/:_id" component={ wrapGrid(ViewAudition) } />

						<Route path="/manage-artists/" exact component={ ManageArtists } />
						<Route path="/manage-songs/" exact component={ ManageSongs } />
						<Route path="/manage-albums/" exact component={ ManageAlbums } />
						<Route path="/manage-users/" exact component={ ManageUsers } />
						<Route path="/artist/view/:id" component={ ArtistForm } />
						<Route path="/users/view/:id" component={ UserForm } />
						<Route path="/manage-fans/:status/:tier?" exact component={ wrapGrid(ManageFans) } />

						<Route path="/manage-lists" exact component={ wrapGrid(ManageLists) } />
						<Route path="/list-editor/:_id" exact component={ wrapGrid(ListEditor) } />

						<Route path="/artist/info/:_id" exact component={ wrapGrid(ArtistInfo) } />
						<Route path="/artist/library/:_id" exact component={ wrapGrid(ArtistInfo) } />

						<Route path="/user/info/:_id" exact component={ wrapGrid(FanInfo) } />

						<Route path="/manage-images" exact component={ wrapGrid(ManageImages) } />

						<Route path="/featured-artists" exact component={ wrapGrid(FeaturedArtists) } />

						<Route path="/manage-documents/:type?" exact component={ wrapGrid(ManageDocuments) } />

						<Route path="/manage-genres" exact component={ wrapGrid(Genres) } />

						{/* Coming soon! */}
						<Route path="/labels" exact component={ wrapGrid(Labels) } />
						<Route path="/manage-subscriptions" exact component={ wrapGrid(ManageSubscriptions) } />
						<Route path="/dashboard" exact component={ wrapGrid(Dashboard) } />
						<Route path="/muzado-radio" exact component={ wrapGrid(MuzadoRadio) } />
						

						{/* Old backup */}
						{/* <Route path="/manage-hfm-picks" exact component={ wrapGrid(HFMPicks) } /> */}
						{/* <Route path="/manage-hfm-radio" exact component={ wrapGrid(HFMRadio) } /> */}
					</div>
					</div>

					<div className="expanded row grid-x">
						<div className="cell">
							<footer>
								{/* NEW WAY */}
								{/* <Route>
									<MusicPlayer />
								</Route>  */}
								 {/* <MusicPlayer { ...this.props }  /> OLD WAY */}
								
							</footer>
						</div>
					</div>

					<ToastContainer />
				</div>
			</Router>
		);//
	}

	@autobind
	onLocationChange () {
		const { routingStore, artistStore, userStore } = this.props;
		const { hash = '' } = routingStore.location;
		const artistIDMatch = hash.match(regex.artistUUIDv5);

		if (artistIDMatch) {

			const artistID = _.get(artistIDMatch, 1);

			artistStore.setCurrent(artistID);
			userStore.setCurrent(artistStore.data.artist.get('userID'));
			return;
		}

		const artistFilterMatch = hash.match(/artists\/(\w+)\/?(\w*)$/i);

		if (artistFilterMatch) {

			const [, status, tier] = artistFilterMatch;
			const { artistStore } = this.props;

			artistStore.setStatusFilter(status);

			if (tier) {

				artistStore.setTierFilter(tier);
			}

			return;
		}

		// const documentFilterMatch = hash.match(/content\/(\w+)/i);

		// if (documentFilterMatch) {
		// 	const [, documentType] = documentFilterMatch;
		// 	const { documentStore } = this.props;
		// 	documentStore.setTypeFilter(documentType);
		// 	return;
		// }

	}
}

Root.propTypes = {
	routingStore: PropTypes.object,
	history: PropTypes.object
};

export default Root;
